import { dataModelPolicies as policies } from 'helpers';
import Schema from './schema';


export default class DataModel extends Schema {

  constructor(values) {
    super(policies, values);

    this.setDtoDefinition({
      baseUrl: '',
      f: '',
      fromEdit: false,
      txt: ''
    });
  }

  setValues(data) {
    this.values = this.dtoDefinition;
    this.setDefaultValues(data);
  }
}
